//region :: Imports ::
import React, {ReactElement} from 'react';
import MComponent from './Toolkit/Components/Component';
import MShell from './Toolkit/Components/Shell/Shell';
import WithRouterProps from './Toolkit/WithRouterProps';
import withRouter from './Toolkit/WithRouter';
import MAuthenticate from './Toolkit/Components/Auth/Authenticate';
import MAuthorize from './Toolkit/Components/Auth/Authorize';
import { MsalContext } from '@azure/msal-react';
import EnumClass from './Context/EnumClass';

//endregion

/** */
type Props = WithRouterProps & {}

/** */
class App extends MComponent<Props> {

    static contextType = MsalContext;

    /** */
    public constructor(props: Props) {
        super(props);

        this.bindMethods();

    }

    /** */
    private bindMethods(): void {

        this.homeButton_onClick = this.homeButton_onClick.bind(this);

    }

    private homeButton_onClick(): void {
        this.props.navigate('/requests');
    }

    /** */
    public render(): ReactElement {
        return (
            <MAuthenticate >
                <MAuthorize roles={['Planner','Quotation','Booking','Supervisor']}>
                    <EnumClass>
                        <MShell appTitle={process.env.REACT_APP_NAME!}
                                topbarButtons={
                                    [

                                    ]
                                }/>
                    </EnumClass>
                </MAuthorize>
            </MAuthenticate>
        );

    }

}

export default withRouter(App);
